import React from 'react';
import NewDetailPackageInfo from './NewDetailPackageInfo';

const MobilePackageInfo = (props) => <NewDetailPackageInfo {...props} />;

export default MobilePackageInfo;
